import type { LucideIcon } from "lucide-react"

export default function EmptyState({ icon: Icon, title, description, className = '', children }: { icon: LucideIcon, title: string, description?: string, primary?: string, className?: string, children?: React.ReactNode }) {
  return (
    <div className={`w-full flex flex-col items-center text-center px-6 py-20 sm:py-28 ${className}`}>
      <Icon aria-hidden className="size-10 sm:size-12 text-muted-foreground" strokeWidth={1} />
      <h3 className="mt-6 text-xl sm:text-2xl tracking-tight text-foreground">{title}</h3>
      {description && <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted-foreground">{description}</p>}
      {children && <div className="mt-8">{children}</div>}
    </div>
  )
}
